import React from 'react';
import App from '../../App';

const AppWrapper = () => {
  // Only redirect in production
  if (process.env.NODE_ENV === 'production') {
    const isAppPath = window.location.pathname.startsWith('/app');
    
    if (!isAppPath && window.location.pathname === '/') {
      window.location.href = '/app/';
      return null;
    }
  }

  return <App />;
};

export default AppWrapper;